module.exports = __webpack_public_path__ + "static/media/compliance--mobile.7d1201f1.png";